module.exports = __webpack_public_path__ + "img/profile.a4d8e03f.jpg";